import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01bc7875"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "num"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: "https://static-s.theckb.com/BusinessMarket/Client/cancel_order_tip_icon.png",
  alt: ""
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "showBox"
}
const _hoisted_4 = { class: "header flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://static-s.theckb.com/BusinessMarket/Client/cancel_order_header_icon.png",
  alt: ""
}, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "list" }
const _hoisted_10 = { class: "product_info" }
const _hoisted_11 = { class: "productSku flex-ter" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "THECKB SKU：", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "productNum flex-ter" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "reason flex-ter" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "value line--only" }
const _hoisted_20 = { class: "footer" }
const _hoisted_21 = {
  key: 1,
  class: "noData"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "no_data_icon",
  src: "https://static-s.theckb.com/BusinessMarket/Client/cancel_no_data.png",
  alt: ""
}, null, -1))
const _hoisted_23 = { class: "tips" }

import { querySystemCancelOrder, handleSystemCancelOrder, CancelOrderProps } from '@/apis/order'
import { ref, onMounted, computed } from 'vue'
import QuestionReason from '@/views/usercenter/Order/AbnormalOrder/QuestionReason.vue'
import { t } from '@/plugins/i18n'
import { isJA, useRtfix } from '@/store'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import Image from '@/components/common/Image.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()
// 是否展示详情
const visible = ref(false)
// 取消订单列表
const cancelList = ref<CancelOrderProps[]>([])
const isLogin = computed(() => store.getters.isLogin)
const customerShopId = computed(() => store.getters.curShop)
const showCancel = () => {
  visible.value = !visible.value
}

const routeName = computed(() => route.name as string)

// 查看取消订单
const checkCancelOrder = async () => {
  const ids = cancelList.value.map(i => i?.abnormalOrderId ?? '')
  const productSkuList = cancelList.value.map(i => i?.productSku ?? '')
  const platformOrderNoList = cancelList.value.map(i => i?.platformOrderNo ?? '')
  await handleSystemCancelOrder({ abnormalOrderIds: ids })
  sessionStorage.setItem('productSkuList', productSkuList.join(','))
  sessionStorage.setItem('platformOrderNoList', platformOrderNoList.join(','))
  visible.value = false
  cancelList.value = []
  if (routeName.value?.startsWith('AbnormalOrder')) {
    router.replace(useRtfix('AbnormalOrder', { query: { abnormal: 'ApplyCancel', t: Date.now() } }))
  } else {
    router.push(useRtfix('AbnormalOrder', { query: { abnormal: 'ApplyCancel' } }))
  }
}
let abnormalOrderIds: string[] = []
let isFirst = true
// 获取取消订单
const getCancelOrder = async () => {
  if (isLogin.value && customerShopId.value && isJA()) {
    const res = await querySystemCancelOrder()
    cancelList.value = res.data
    if (!isFirst) {
      res.data?.forEach((item: { abnormalOrderId: string }) => {
        if (!abnormalOrderIds.includes(item.abnormalOrderId)) {
          visible.value = true
          // timeoutHidden()
        }
      })
    }
    abnormalOrderIds = res.data?.map(v => v.abnormalOrderId)
    isFirst = false
  }
}
let timer:any = null
const timeoutHidden = () => {
  clearTimeout(timer)
  timer = setTimeout(() => {
    visible.value = false
  }, 5000)
}
onMounted(async () => {
  const cancelOrderShow:string = localStorage.getItem('cancelOrderShow') ?? ''
  if (cancelOrderShow !== '0') {
    await getCancelOrder()
  }
  setInterval(async () => {
    await getCancelOrder()
  }, 30000)
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", {
      class: "container",
      onClick: showCancel
    }, [
      (cancelList.value?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(cancelList.value?.length), 1))
        : _createCommentVNode("", true),
      _hoisted_2
    ], 512), [
      [_vShow, cancelList.value?.length]
    ]),
    (cancelList.value?.length)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (cancelList.value?.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)('您有X个sku被取消，请及时查看').replace('X', cancelList.value?.length)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)('通知')), 1)),
            _createElementVNode("span", {
              class: "iconfont icon-guanbi2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
            })
          ]),
          (cancelList.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cancelList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "item",
                      key: index
                    }, [
                      _createVNode(Image, {
                        class: "productSkuImg",
                        src: item?.productSkuImg || item?.productMainImg
                      }, null, 8, ["src"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, _toDisplayString(item.productSku), 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('取消数量')) + "：", 1),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(item?.cancelQuantity), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('取消原因')) + "：", 1),
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_el_tooltip, { effect: "customized" }, {
                              default: _withCtx(() => [
                                _createVNode(QuestionReason, {
                                  item: item,
                                  type: item?.processManner,
                                  isTip: true
                                }, null, 8, ["item", "type"])
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", {
                    class: "check_btn",
                    onClick: checkCancelOrder
                  }, _toDisplayString(_unref(t)('立即查看')), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('如有sku被取消，会实时通知在这里')), 1)
              ]))
        ], 512)), [
          [_vShow, visible.value]
        ])
      : _createCommentVNode("", true)
  ], 64))
}
}

})